var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22222 1H1V7.22222H7.22222V1Z",
    stroke: "url(#paint0_linear_5_2454)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1H10.7778V7.22222H17V1Z",
    stroke: "url(#paint1_linear_5_2454)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.7778H10.7778V17H17V10.7778Z",
    stroke: "url(#paint2_linear_5_2454)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22222 10.7778H1V17H7.22222V10.7778Z",
    stroke: "url(#paint3_linear_5_2454)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_2454",
    x1: 9,
    y1: 1,
    x2: 9,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D172A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_2454",
    x1: 9,
    y1: 1,
    x2: 9,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D172A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_2454",
    x1: 9,
    y1: 1,
    x2: 9,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D172A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_2454",
    x1: 9,
    y1: 1,
    x2: 9,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D172A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/CategoryIcon.0aa1dcc576f6e5b404dc905c7e4b3ce3.svg";
export { ForwardRef as ReactComponent };